
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'lazysizes';
import Splide from '@splidejs/splide';
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

// Gallery
if (document.querySelector('.gallery')){
  const thumbs = new Splide( '.gallery-thumbs', {
    rewind      : false,
    isNavigation: true,
    gap         : 16,
    pagination  : false,
    arrows: false,
    perPage: 7,
    breakpoints: {
      1280: {
        perPage: 5
      },
      1024: {
        perPage: 3,
      },
    }
  } );

  const gallery = new Splide( '.gallery', {
    type       : 'fade',
    pagination : false,
    autoHeight: false,
    autoWidth:false,
    arrowPath: 'M29.5900788,11.1925227 L29.6866235,11.2729868 L39.4564022,20.4999974 L29.6866235,29.7270132 C29.2851053,30.1062249 28.6521986,30.0881418 28.2729868,29.6866235 C27.9229453,29.3159913 27.911427,28.7481997 28.2275313,28.3647799 L28.3133765,28.2729868 L35.484,21.4999974 L2,21.4999974 C1.44771525,21.4999974 1,21.0522847 1,20.4999974 C1,19.9871642 1.38604019,19.5644928 1.88337887,19.5067277 L2,19.4999974 L35.484,19.4999974 L28.3133765,12.7270132 C27.9427442,12.3769716 27.898826,11.8107639 28.1925227,11.4099212 L28.2729868,11.3133765 C28.5938583,10.9736302 29.0963693,10.9084145 29.4866438,11.1261259 L29.5900788,11.1925227 Z',
  } );

  gallery.sync( thumbs );
  gallery.mount();
  thumbs.mount();
}
